export default {
  setSelectedYear (state: {[key:string]: string}, value: string) {
    state.selectedYear = value
  },
  setSelectedSeason (state: {[key:string]: string}, value: string) {
    state.selectedSeason = value
  },
  setSelectedStatus (state: {[key:string]: any}, value: number[]) {
    state.selectedStatus = value
  },
  setSelectedVariety (state: {[key:string]: any}, value: string) {
    state.selectedVariety = value
  },
  setSelectedGrade (state: {[key:string]: any}, value: string) {
    state.selectedGrade = value
  },
  setWord (state: {[key:string]: any}, word: string) {
    state.word = word
  },
  setCurrentPage (state: {[key:string]: any}, page: number) {
    state.currentPage = page
  },
  setOrderName (state: {[key:string]: any}, order: string) {
    state.orderName = order
  },
  setSort (state: {[key:string]: any}, sort: string) {
    state.sort = sort
  },
  setModalOrderName (state: {[key:string]: any}, order: string) {
    state.modalOrderName = order
  },
  setModalSort (state: {[key:string]: any}, sort: string) {
    state.modalSort = sort
  }
}
